import React from 'react';
import NgoSidebar from './NgoSidebar';
import NgoHeader from './NgoHeader';
import "../../assets/css/layout/ngo/NgoLayout.css";
const NgoLayout = ({ children }) => {
  return (
    <div className="ngo-layout">
      
      {/* Sidebar - Fixed position */}
      <NgoSidebar />

      {/* Header - Fixed position */}
      <NgoHeader />

      {/* Main Content Area */}
      <main className="ngo-main">
        <div className="ngo-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default NgoLayout;
